import ReactGA from "react-ga4";

export class Analytics {
  static get hasToken() {
    return process.env.REACT_APP_GOOGLE_ANALYTICS_ID !== "";
  }

  static init() {
    if (!this.hasToken) return;
    ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_ID);
  }

  static pageView(path: string) {
    if (!this.hasToken) return;
    ReactGA.send({ hitType: "pageview", page: path });
  }

  static setUserId(userId: string) {
    ReactGA.set({ userId });
  }
  static setUserProperties(properties: { [key: string]: any }) {
    ReactGA.set({ userProperties: properties });
  }

  static event({
    action,
    category,
    params,
  }: {
    action: string;
    category: string;
    params?: { [key: string]: string };
  }) {
    if (!this.hasToken) return;
    ReactGA.send({
      hitType: "event",
      eventCategory: category,
      eventAction: action,
      ...params,
    });
  }
}
